<template>
    <v-container fluid class="pa-0">
        <v-slide-group v-if="type === 'Document'" class="custom-carousel" show-arrows center-active>
            <v-slide-group-item v-for="(possibility, index) in possibilities" :key="index">
                <v-btn
                    class="mx-1 my-3"
                    size="x-small"
                    elevation="0"
                    @click="insertQuestion(possibility)"
                >
                    {{ translate(possibility) }}
                </v-btn>
            </v-slide-group-item>
        </v-slide-group>

        <oss-dialog
            v-model="dialog"
            :max-width="!$vuetify.display.mobile ? '650px' : undefined"
            :fullscreen="$vuetify.display.mobile"
            :hide-overlay="$vuetify.display.mobile"
            @keydown.esc="dialog = false"
            :title="titleDialog"
            @valid="sendAsk()"
            valid-text="Send"
        >
            <v-row no-gutters>
                <v-col cols="12" class="d-flex justify-end">
                    <div class="myMessages">{{ defaultQuestion(askSelected) }}{{ question }}</div>
                </v-col>
                <v-col cols="12">
                    <v-textarea v-model="question" label="Ecrivez votre propre message" rows="3" />
                </v-col>
            </v-row>

            <!-- <v-flex xs12 class="d-flex justify-end">
                <v-btn
                    color="secondary"
                    elevation="0"
                    rounded
                    @click="sendAsk()"
                >
                    Send <v-icon right>send</v-icon>
                </v-btn>
            </v-flex> -->
        </oss-dialog>
    </v-container>
</template>

<script lang="ts">
import { Apollo } from "@/decorators";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";

@Component({
    emits: ["sendMessage", "smartAsk", "insertQuestion"],
})
export class CMRequests extends Vue {
    @Prop({ default: "" }) type: string;

    @Prop({ default: [] }) smartMessages: any;

    @Prop({ default: null }) info: any;

    show = false;

    // List of smart ask and no answered
    smarkAsked = [];

    askSelected = "";

    dialog = false;

    question = "";

    get smartMessageNotAsked() {
        if (this.smartMessages && this.smartMessages.length) {
            return this.smartMessages.map((x) => x.smartAsk);
        }
        return [];
    }

    get possibilities() {
        switch (this.type) {
            case "Document": {
                return [
                    "VAT_RATE",
                    "VAT_AMOUNT",
                    "TTC",
                    "HT",
                    "DATE",
                    "DUE_DATE",
                    "THIRD_PARTY_COMPANY",
                    "LOW_QUALITY",
                ];
            }
        }
        return [];
    }

    get titleDialog() {
        switch (this.askSelected) {
            case "VAT_RATE": {
                return this.$t("document.common.vatRate");
            }
            case "VAT_AMOUNT": {
                return this.$t("document.common.vatAmount");
            }
            case "TTC": {
                return this.$t("document.common.netAmount");
            }
            case "HT": {
                return this.$t("document.common.grossAmount");
            }
            case "DATE": {
                return this.$t("shared.date");
            }
            case "DUE_DATE": {
                return this.$t("shared.dueDate");
            }
            case "THIRD_PARTY_COMPANY": {
                return this.$t("document.common.thirdParty");
            }
            case "LOW_QUALITY": {
                return this.$t("chat.smartAsk.titleDialog.lowQuality");
            }
        }
        return this.askSelected;
    }

    defaultQuestion = function ListOfQuestionsByDefaultForEachType(type: string) {
        switch (type) {
            case "VAT_RATE": {
                return this.$t("chat.smartAsk.defaultQuestions.vatRate") + " ";
            }
            case "VAT_AMOUNT": {
                return this.$t("chat.smartAsk.defaultQuestions.vatAmount") + " ";
            }
            case "TTC": {
                return this.$t("chat.smartAsk.defaultQuestions.netAmount") + " ";
            }
            case "HT": {
                return this.$t("chat.smartAsk.defaultQuestions.grossAmount") + " ";
            }
            case "DATE": {
                return this.$t("chat.smartAsk.defaultQuestions.date") + " ";
            }
            case "DUE_DATE": {
                return this.$t("chat.smartAsk.defaultQuestions.dueDate") + " ";
            }
            case "THIRD_PARTY_COMPANY": {
                return this.$t("chat.smartAsk.defaultQuestions.thirdCompany") + " ";
            }
            case "LOW_QUALITY": {
                return this.$t("chat.smartAsk.defaultQuestions.lowQuality") + " ";
            }
        }
        return this.askSelected;
    };

    translate = function translationOfButtonNames(value: string) {
        switch (value) {
            case "VAT_RATE": {
                return this.$t("document.common.vatRate");
            }
            case "VAT_AMOUNT": {
                return this.$t("document.common.vatAmount");
            }
            case "TTC": {
                return this.$t("document.common.netAmount");
            }
            case "HT": {
                return this.$t("document.common.grossAmount");
            }
            case "DATE": {
                return this.$t("shared.date");
            }
            case "DUE_DATE": {
                return this.$t("shared.dueDate");
            }
            case "THIRD_PARTY_COMPANY": {
                if (this.info.type === "SALES_INVOICE") {
                    return this.$t("document.common.thirdPartyClient");
                }
                return this.$t("document.common.thirdPartyProvider");
            }
            case "LOW_QUALITY": {
                return this.$t("chat.smartAsk.buttonName.lowQuality");
            }
        }
        return value;
    };

    emit = function sendRequestForMissingInformationToChatManager(smartAskFor: string) {
        this.$emit("smartAsk", { for: smartAskFor });
        this.smartAsk.push(smartAskFor);
    };

    selectionRequest = function selectionOfTheRequestAndDisplayOfTheDialog(askType: string) {
        this.askSelected = askType;
        this.dialog = true;
    };

    sendAsk = function sendingSmartMessageToChatManager() {
        this.$emit("sendMessage", {
            type: this.askSelected,
            message: this.defaultQuestion(this.askSelected) + this.question,
        });
        this.dialog = false;
        this.question = "";
        this.askSelected = "";
    };

    insertQuestion(type: string) {
        this.$emit("insertQuestion", {
            type: type,
            message: this.defaultQuestion(type),
        });
    }
}

export default toNative(CMRequests);
</script>
<style>
.v-slide-group__next,
.v-slide-group__prev {
    min-width: auto; /* Removes the minimum width imposed by Vuetify */
    width: auto; /* Allows buttons to adapt to their content */
}
</style>
